import * as React from 'react'
import getConfig from 'next/config'
import WebpImg from 'components/Image/WebpImg'

const {
  publicRuntimeConfig: { androidLink: defaultLink },
} = getConfig()

const GooglePlay = ({ width = 155, link = defaultLink }) => {
  return (
    <a href={link}>
      <WebpImg
        imgSrc="https://play.google.com/intl/en_us/badges/images/generic/ja_badge_web_generic.png"
        imgProps={{ alt: 'Google Play で手に入れよう' }}
        style={{ width }}
      />
    </a>
  )
}

export default GooglePlay
